@for(formGroup of formArray().controls; track formGroup.value.id; let i =
$index){
<div class="my-3">
  <div class="card">
    <div class="card-header">
      <span>{{ title() | translate }}</span>
      <div
        class="form-array-card__remove me-1 mb-1"
        [class.form-array-card__remove--disabled]="disabled()"
        [attr.aria-disabled]="disabled()"
        (click)="!disabled() && remove.emit(i)"
      >
        <span class="fas fa-trash-alt me-1"></span
        >{{ "general.remove" | translate }}
      </div>
    </div>
    <div class="card-body">
      <ng-container
        *ngIf="itemTemplate()"
        [ngTemplateOutlet]="itemTemplate()"
        [ngTemplateOutletContext]="{ $implicit: formGroup }"
      ></ng-container>
    </div>
  </div>
</div>
}

<div class="add-row">
  <button
    class="btn btn-outline-primary btn-sm"
    type="button"
    [disabled]="disabled()"
    (click)="add.emit()"
  >
    <span class="fas fa-plus"></span> {{ addButtonTitle() | translate }}
  </button>
</div>
